module.exports = __webpack_public_path__ + "static/js/893.3b6c41a5.chunk.worker.js"